import React, { useEffect, useState } from 'react'
import { Style } from './styleTop'
import { Text } from '../style'
import IMG from '@assets/dashboard'
import numeral from 'numeral'
import { setLocalStorage, isEmptyValue } from '@helpers'
import { useTranslation } from 'react-i18next';

const generateTodayEnergy = value => {
  let t = value
  let name = 'Wh'

  if (value >= 1_000_000) {
    t = value / 1_000_000
    name = 'MWh'
  } else if (value >= 1000) {
    t = value / 1000
    name = 'kWh'
  }
  return { value: numeral(t).format('0,0.00'), unit: name }
}

export const Top = ({
  pvGenerationDay,
  pvGenerationTotal,
  temperature,
  dateToday,
  address,
  systemInfo,
  isEng,
  power,
  id,
}) => {
  const [icon, setIcon] = useState(1)
  const [iconSun, setIconSun] = useState<any>()
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      const newIcon = icon + 1
      if (newIcon === 5) {
        setIcon(1)
      } else {
        setIcon(newIcon)
      }
    }, 800)
  }, [icon])
  const img = `energy-${icon === 1 || icon === 2 ? 1 : 2}.svg`

  useEffect(() => {
    setInterval(() => {
      const date = new Date()
      const format = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
      const startDate = date.getTime()
      const sun1 = { time: startDate - new Date(`${format} 05:00`).getTime(), icon: 'sun-1.svg' }
      const sun2 = { time: startDate - new Date(`${format} 10:00`).getTime(), icon: 'sun-2.svg' }
      const sun3 = { time: startDate - new Date(`${format} 16:00`).getTime(), icon: 'sun-3.svg' }
      const sunImg = [sun1, sun2, sun3]
        .sort((a, b) => a.time - b.time)
        .filter(({ time }) => time > 0)[0]?.icon
      if (iconSun !== sunImg) {
        setIconSun(sunImg)
      }
    }, 1000)
  }, [])
  
  const changeLanguage = key => {
    setLocalStorage('LANGUAGE', key)
    i18n.changeLanguage(key);
  }


  return (
    <Style $opacity={icon === 2 || icon === 4 ? 0.3 : 1}>
      <div className='column-1'>
        <div className='system'>
          <img className='box' src={IMG['system-box.svg']} alt={IMG['system-box.svg']} />
          <img className='icon' src={IMG['system.svg']} alt={IMG['system.svg']} />
          <div className='text'>
            <Text $maxSize='0.6' $minSize='10' top={'29%'}>
              {t('top.information')}
            </Text>
            <Text $maxSize='0.6' $minSize='10'>
              {t('top.capacity')} :
            </Text>
            <Text $maxSize='1.5' $minSize='24'>
              {power} kWp
            </Text>
            <Text $maxSize='0.6' $minSize='10'>
              {t('top.commissioning')} :
            </Text>
            <Text $maxSize='1.3' $minSize='22'>
              {systemInfo?.startUpUtc || '-'}
            </Text>
          </div>
        </div>
      </div>
      <div className='column-2'>
        <div className='energy'>
          <img className='box' src={IMG['energy-box.svg']} alt={IMG['energy-box.svg']} />
          <img className='icon' src={IMG[img]} alt={IMG[img]} />
          <div className='text'>
            <Text $maxSize='1.6' $minSize='26' top={isEng ? '8%' : '4.5%'}>
              {t('top.energyToday')} :
            </Text>
            <Text $maxSize='3' $minSize='50' top={'-1%'}>
              {isEmptyValue({
                valueCheck: pvGenerationDay,
                display: generateTodayEnergy(pvGenerationDay).value,
              })}{' '}
              {generateTodayEnergy(pvGenerationDay).unit}
            </Text>
            <Text $maxSize='1.2' $minSize='20' top='-1%'>
              {t('top.totalEnergy')} :{' '}
              {isEmptyValue({
                valueCheck: pvGenerationTotal,
                display: generateTodayEnergy(pvGenerationTotal).value,
              })}{' '}
              {generateTodayEnergy(pvGenerationTotal).unit}
            </Text>
          </div>
        </div>
      </div>
      <div className='column-3'>
        <div className='animation'>
          <img className='sun' src={IMG[iconSun]} alt={IMG[iconSun]} />
          <img className='cloud-1' src={IMG['cloud.svg']} alt={IMG['cloud.svg']} />
          <img className='cloud-2' src={IMG['cloud.svg']} alt={IMG['cloud.svg']} />
        </div>
        <div className='date'>
          <div className='calendar'>
            <img className='img-calendar' src={IMG['calendar.svg']} alt={IMG['calendar.svg']} />
          </div>
          <div className='text'>
            <Text $maxSize='1' $minSize='16'>
              {dateToday.format('DD MMM YYYY')}
            </Text>
          </div>
          <div className='flex'>
            <Text
              className='language'
              $maxSize='1'
              $minSize='16'
              left='16px'
              right='6px'
              onClick={() => changeLanguage('en')}
            >
              EN
            </Text>{' '}
            |{' '}
            <Text
              className='language'
              $maxSize='1'
              $minSize='16'
              left='6px'
              onClick={() => changeLanguage('jp')}
            >
              JP
            </Text>
          </div>
        </div>
        <div className='address'>
          <img className='pin' src={IMG['pin.svg']} alt={IMG['pin.svg']} />
          <div className='map'>
            {address?.city ? (
              <div className='text'>
                <Text $maxSize='0.8' $minSize='12' top='-4%'>
                  {address.city}
                </Text>
                <Text $maxSize='0.8' $minSize='12'>
                  {address.timezone}
                </Text>
              </div>
            ) : (
              <Text left={'55%'} top={'6%'}>
                -
              </Text>
            )}
          </div>
        </div>
        <div className='temperature'>
          <Text $maxSize='1' $minSize='16' top='1%'>
            {t('top.temperature')} :
          </Text>
          <div className='flex'>
            <div className='flex'>
              <img
                className='icon-1'
                src={IMG['temperature-1.svg']}
                alt={IMG['temperature-1.svg']}
              />
              <Text $maxSize='2.6' $minSize='40' top='3%' left='4%'>
                {isEmptyValue({
                  valueCheck: temperature?.moduleTemperature,
                  display: Math.round(temperature?.moduleTemperature),
                })}
              </Text>
              <div className='circle' />
              <Text $maxSize='2.6' $minSize='40' top='3%'>
                C
              </Text>
            </div>
            <div className='flex'>
              <img
                className='icon-2'
                src={IMG['temperature-2.svg']}
                alt={IMG['temperature-2.svg']}
              />
              <Text $maxSize='2.6' $minSize='40' top='3%' left='-6%'>
                {isEmptyValue({
                  valueCheck: temperature?.ambientTemperature,
                  display: Math.round(temperature?.ambientTemperature),
                })}
              </Text>
              <div className='circle' />
              <Text $maxSize='2.6' $minSize='40' top='3%'>
                C
              </Text>
            </div>
          </div>
        </div>
      </div>
    </Style>
  )
}
